import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment-timezone";

import * as Middleware from "@middlewares/index";
import useCheckFavorites from "@helpers/useCheckFavorites";
import FavoritesButton from "@components/FavoritesButton";
import { userCutawayStatus } from "@helpers/UserCutawayStatus";
import { NetworkingFillStatus } from "@interface/enums";

interface IProps {
  user: {
    company: {
      companyImage: string | null;
      title: string;
    };
    firstName: string;
    id: number;
    lastName: string;
    position: string;
    userImage: string | null;
  };
}

const NetworkingUser: React.FC<IProps> = ({ user }) => {
  const profile = useSelector((state) => state.Profile?.data);
  const workshopData = useSelector((state: any) => state.Main.Workshop.data);
  const registerEndAt = moment(workshopData.registerEndAt)
    .tz("Europe/Moscow")
    .format();
  const now = moment().tz("Europe/Moscow").format();
  const isFavorited = useCheckFavorites(user.id);
  const netwDays = useSelector((state) => state.Networking?.Days.data);
  const cutawayStatus = userCutawayStatus(user);

  return (
    <div
      className={`netw-card netw-card--agent ${
        profile?.id === user.id ? "netw-card--current-profile" : ""
      }`}
    >
      <FavoritesButton
        favoriteType="partner"
        id={user.id}
        isButtonText={false}
        isFavorited={isFavorited}
      />
      <div className="netw-card__body">
        <Link to={`/user/${user.id}`} className="netw-card__logo">
          {user.userImage ? (
            <img
              src={user.userImage}
              alt={`${user.firstName} ${user.lastName}`}
            />
          ) : (
            <img
              src={require("@public/images/defaultAvatarCompany.svg")}
              alt=""
            />
          )}
        </Link>

        <div className="netw-card__content">
          <Link to={`/user/${user.id}`} className="netw-card__title">
            {user.firstName} {user.lastName}
          </Link>
          <p className="netw-card__desc">
            {user.position}
            {user.position && user.company ? ", " : ""}
            {user.company?.title}
          </p>
        </div>
        <div className="netw-card__footer">
          {user.company !== null ? (
            <div className="netw-card__contacts">
              <p className="netw-card__contacts-title">Компания:</p>
              <ul className="netw-card__contacts-list">
                <li className="netw-card__contacts-item">
                  {user.company?.companyImage !== null ? (
                    <img
                      src={user.company?.companyImage}
                      alt={user.company?.title}
                    />
                  ) : (
                    <img
                      src={require("@public/images/defaultAvatarCompany.svg")}
                      alt=""
                    />
                  )}
                </li>
              </ul>
            </div>
          ) : null}

          {profile?.id !== user.id ? (
            <div className="netw-card__buttons">
              {netwDays.length > 0 && (
                <Link
                  className="btn btn--white-blue"
                  to={`/user/${user.id}/event/create`}
                  onClick={(event) => {
                    if (now > registerEndAt) {
                      event.preventDefault();
                      Middleware.Ui.Modal.open("EndEvent", { callback: "" });
                    } else if (
                      !(
                        profile?.useNetworking &&
                        profile?.networkingFillStatus ===
                          NetworkingFillStatus.Complete
                      )
                    ) {
                      event.preventDefault();
                      Middleware.Ui.Modal.open("EnterNetworking");
                    }
                  }}
                >
                  Назначить встречу
                </Link>
              )}

              <Link
                className={`btn btn--blue ${cutawayStatus.status}`}
                to="#"
                onClick={async (event) => {
                  event.preventDefault();
                  if (now > registerEndAt) {
                    Middleware.Ui.Modal.open("EndEvent", { callback: "" });
                  } else if (
                    profile?.useNetworking &&
                    profile?.networkingFillStatus ===
                      NetworkingFillStatus.Complete
                  ) {
                    try {
                      await Middleware.User.Cutaway.invite(user.id);
                      await Middleware.Networking.User.setUserCutawayStatus(
                        0,
                        user.id
                      );
                    } catch (Exception) {
                      throw Exception;
                    }
                  } else {
                    Middleware.Ui.Modal.open("EnterNetworking");
                  }
                }}
              >
                {cutawayStatus.text}
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NetworkingUser;
